<template lang="pug">
div
  .tabs.u-mb-xs
    ul
      li(v-for='tab in tabs', :class="{ 'is-active': tab.isActive }")
        a( @click='selectTab(tab)' class="tabs-button") {{ tab.name }}
  .tabs-body
    slot

</template>

<script>
export default {
  name: 'TabbedContainer',
  data() {
    return { tabs: [] };
  },
  created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.href === selectedTab.href;
      });
    }
  }
};
</script>
<style lang="stylus">
@import '~assets/css/vars.styl'

.tabs
  > ul
    list-style-type: none
    padding: 0

    >li
      display: inline-block
      padding-right: unitRes(16, 32)
      position: relative
      margin-bottom: unitRes(16, 32)
      font-size: $header5

      // +mq($until: 'mobile')
      // display: block
      &:after
        content: ''
        width: 100%
        height: 0.25em
        background: $clBlack
        position: absolute
        left: 0
        bottom: 0
        z-index: -1

      a
        padding-right: unitRes(16, 32)

      &.is-active
        a
          color: $clPrimary
          background-image: linear-gradient(to right, $clPrimary 0%, $clPrimary 100%)
          background-size: 100% 0.32em

  &-button
    cursor: pointer
    position: relative
    box-shadow: none
    background-image: linear-gradient(to right, $clBlack 0%, $clBlack 100%)
    background-size: 100% 0.25em
    background-position: 0px 100%
    background-repeat: repeat-x
    padding: 0 0.5em 0.2em 0
    color: $clBlack
    font-weight: $fontWeight-bold
    line-height: 1.4
    font-size: $header5
    border: 0
    transition: background-size 0.2s ease-in-out
    text-align: initial

    &:hover
      color: $clPrimary
      background-image: linear-gradient(to right, $clPrimary 0%, $clPrimary 100%)
      background-size: 100% 0.32em

  &-body
    position: relative

    .grid
      margin-right: -2vw
      margin-left: -2vw

      .column
        padding-right: 2vw
        padding-left: 2vw
</style>
